import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useArticleView } from '../ArticleViewContext';
import ArticlePanel from './ArticlePanel';
import ArticleViewContent, { ArticleViewMobileTitle } from './ArticleViewContent';

export default function ArticleViewLayout({ panelManaged = false }) {
    const { open, onClose, isMobile } = useArticleView();
    const content = isMobile ? (
        <>
            <DialogTitle><ArticleViewMobileTitle /></DialogTitle>
            <DialogContent dividers><ArticleViewContent /></DialogContent>
            <DialogActions><Button onClick={onClose}>Sulje</Button></DialogActions>
        </>
    ) : <ArticleViewContent />;

    return panelManaged ? content : (
        <ArticlePanel open={open} onClose={onClose} isMobile={isMobile}>
            {content}
        </ArticlePanel>
    );
}
